// src/features/engine/components/UIBlock.jsx

export default function UIBlock({ title, text, variant = "info" }) {

  const styles = {
    info: {
      background: "#f7f9fc",
      border: "1px solid #d6e4ff"
    },
    warning: {
      background: "#fff8e6",
      border: "1px solid #ffe58f"
    }
  };

  return (
    <div
      style={{
        marginTop: 20,
        padding: 16,
        borderRadius: 6,
        ...styles[variant]
      }}
    >
      {title && <h3 style={{ marginTop: 0 }}>{title}</h3>}
      {text && <p style={{ marginBottom: 0 }}>{text}</p>}
    </div>
  );
}